import { jsonProperty, Serializable } from "ts-serializable";

class Exam extends Serializable{

    @jsonProperty(String, null)
    id: string | null = null;

    @jsonProperty(String, null)
    nome: string | null = null;

    @jsonProperty(Number, null)
    intervaloMeses: number | null = null;

    @jsonProperty(String, null)
    formato: string | null = null;

    @jsonProperty(Boolean)
    inativo: boolean = false;

}  

export default Exam;